import { useState, useEffect } from 'react';
import { Typography, FormControl, Select, MenuItem, IconButton, TextField, Button, Menu, Box } from "@mui/material";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ClearIcon from '@mui/icons-material/Clear';
import {
  HelpNote, Column, AdminFiltersWrapper
 } from "./style";
import { statusForAdmin } from '../../../functions/ticketsStatus'
import axios from '../../../functions/requestInterceptor'
import { useTranslation } from 'react-i18next';
import { formatRelativeTime } from '../../../functions/time.ts'

const normalizeDigits = (value) => value
  .replace(/[۰-۹]/g, (digit) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(digit)))
  .replace(/[٠-٩]/g, (digit) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit)))
  .replace(/\D/g, '')

export default function Header(props) {
  const { t, i18n } = useTranslation('translation', { keyPrefix: 'chat' });

  const { handleChangeStatus } = props
  const selfUser = JSON.parse(localStorage.getItem('user'))

  const [status, setStatus] = useState(props.status)
  const [reminderAnchorEl, setReminderAnchorEl] = useState(null)
  const [reminderDays, setReminderDays] = useState(1)
  const [deletingReminder, setDeletingReminder] = useState(false)
  const reminderOpen = Boolean(reminderAnchorEl)

  const handleChange = (event) => {
    const newValue = event.target.value
    handleChangeStatus(newValue, true)
  }

  const [category, setCategory] = useState(props.category)

  const handleChangeCategory = (event) => {
    const newValue = event.target.value
    props.handleChangeCategory(newValue)
  }

  useEffect(() => {
    setStatus(props.status)
    setCategory(props.category.id)
  }, [props.status, props.category]);

  const [categoriesOptions, setCategoriesOptions] = useState([])
  useEffect(() => {
    axios.get('/categories/')
    .then((response) => {
      setCategoriesOptions(response.data.results)
      
    })
    .catch((error) => {
      console.log(error)
    });
  }, [])

  const handleOpenReminderMenu = (event) => {
    setReminderAnchorEl(event.currentTarget)
  }

  const handleCloseReminderMenu = () => {
    setReminderAnchorEl(null)
  }

  const handleSelectReminder = (days) => {
    const reminderDate = new Date()
    reminderDate.setDate(reminderDate.getDate() + days)

    axios.post(`/tickets/${props.ticketId}/remiders/`, {
      date: reminderDate.toISOString()
    })
    .then(() => {
      props.handleSetReminder(reminderDate.toISOString())
      handleCloseReminderMenu()
    })
    .catch((error) => {
      console.log(error)
    })
  }

  const handleSubmitReminder = () => {
    const days = Number(reminderDays)
    if (!Number.isInteger(days) || days < 1) {
      return
    }

    handleSelectReminder(days)
  }

  const handleDeleteReminder = () => {
    setDeletingReminder(true)

    axios.delete(`/tickets/${props.ticketId}/remiders/`)
    .then(() => {
      props.handleDeleteReminder?.()
    })
    .catch((error) => {
      console.log(error)
    })
    .finally(() => {
      setDeletingReminder(false)
    })
  }

  const direction = i18n.language === 'en' ? 'ltr' : 'rtl'

  let reminderTitle = 'یادآور'
  if (props.reminder) {
    reminderTitle = formatRelativeTime(props.reminder)
  }

  return (
    <HelpNote>
      {selfUser?.type === 'admin'
      ? <AdminFiltersWrapper>
          <Column>
            <Typography variant="body2" color="text.secondary">
              {t('ticket_status')}
            </Typography>
            <FormControl fullWidth size={'small'}>
              <Select
                value={status}
                onChange={handleChange}
                defaultValue={status}
              >
              {Object.keys(statusForAdmin).map((item) => <MenuItem sx={{direction: direction}} value={item} key={item}>
                {statusForAdmin[item]}
                </MenuItem>)}
            </Select>
          </FormControl>
        </Column>

        <Column>
            <Typography variant="body2" color="text.secondary">
              {t('category')}
            </Typography>
            <FormControl fullWidth size={'small'}>
              <Select
                value={category}
                onChange={handleChangeCategory}
                defaultValue={category}
              >
              {categoriesOptions.map((item) => <MenuItem sx={{direction: direction}} value={item.id} key={item.id}>
                { item.name }
                </MenuItem>)}
            </Select>
          </FormControl>
        </Column>

        <Column>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between'}}>
            <Typography variant="body2" color="text.secondary">
              یادآور
            </Typography>
            <IconButton
              aria-label="reminder"
              aria-controls={reminderOpen ? 'reminder-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={reminderOpen ? 'true' : undefined}
              onClick={handleOpenReminderMenu}
              size="small"
            >
              <NotificationsActiveIcon htmlColor={!!props.reminder ? '#3a9d69' : 'gray'} />
            </IconButton>
          </div>

          <Menu
            id="reminder-menu"
            anchorEl={reminderAnchorEl}
            open={reminderOpen}
            onClose={handleCloseReminderMenu}
            anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
            transformOrigin={{vertical: 'top', horizontal: 'right'}}
          >
            <Box
              sx={{display: 'flex', flexDirection: 'column', gap: 1, p: 1.5, minWidth: 220, direction}}
              onKeyDown={(event) => event.stopPropagation()}
            >
              {!!props.reminder && (
                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1}}>
                  <Typography variant="body2" color="text.secondary">
                    {reminderTitle}
                  </Typography>
                  <IconButton
                    aria-label="delete reminder"
                    onClick={handleDeleteReminder}
                    disabled={deletingReminder}
                    size="small"
                  >
                    <ClearIcon fontSize="small" htmlColor="red" />
                  </IconButton>
                </Box>
              )}
              <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                <TextField
                  aria-label="reminder days"
                  type="text"
                  size="small"
                  value={reminderDays}
                  onChange={(event) => setReminderDays(normalizeDigits(event.target.value))}
                  inputProps={{inputMode: 'numeric', pattern: '[0-9]*'}}
                  sx={{width: 96}}
                />
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleSubmitReminder}
                  disabled={!Number.isInteger(Number(reminderDays)) || Number(reminderDays) < 1}
                >
                  ثبت
                </Button>
              </Box>
            </Box>
          </Menu>
        </Column>
      </AdminFiltersWrapper>
      : props.category.id === 1
        ? <Typography variant="body2" color="text.secondary">
          {t('estekhare_header_5')}
        </Typography>
        : <Typography variant="body2" color="text.secondary">
         {t('voice_hint_1')}
        <b> {t('voice_hint_2')} </b>
         {t('voice_hint_3')}
        <b> {t('voice_hint_4')} </b>
         {t('voice_hint_5')}
      </Typography>}
    </HelpNote>
  )
}
